import React, { useRef, useState } from 'react'

//Custom components
import { CustomDataTable } from '../../../Components/DataTable';
import { Chip } from '../../../Components/Others';

const TABLE_DATA = [
    {
        field: "Email ID",
        old_value: "abc@gmail.com",
        new_value: "xyz@gmail.com",
        registered_date: "18 Sep 2024",
        updated_date: "19 Sep 2024",
        status: "Pending",
        reason: "-",
        time: "08 Jun 2024, 10:30 am"
    },
    {
        field: "Email ID",
        old_value: "abc@gmail.com",
        new_value: "xyz@gmail.com",
        registered_date: "18 Sep 2024",
        updated_date: "19 Sep 2024",
        status: "Rejected",
        reason: "Invalid Number",
        time: "08 Jun 2024, 10:30 am"
    },
    {
        field: "Email ID",
        old_value: "abc@gmail.com",
        new_value: "xyz@gmail.com",
        registered_date: "18 Sep 2024",
        updated_date: "19 Sep 2024",
        status: "Approved",
        reason: "-",
        time: "08 Jun 2024, 10:30 am"
    }
]

const NonFinancialChanges = () => {

    const scrollRef = useRef(null);

    const [currentPage, setCurrentPage] = useState(1);

    // handle table page change 
    const _handlePageChange = (page_num) => {
        setCurrentPage(page_num);
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    };

    const FAMILY_TABLE_COLUMN = [
        {
            name: 'Field Changed',
            selector: row => row.field,
            width: "150px"
        },
        {
            name: 'Old Value',
            selector: row => row.old_value,
            width: "300px",
            sortable: true
        },
        {
            name: 'New Value',
            selector: row => row.new_value,
            width: "300px"
        },
        {
            name: 'Requested date',
            selector: row => row.registered_date,
            width: "150px"
        },
        {
            name: 'Updated date',
            selector: row => row.updated_date,
            width: "150px"
        },
        {
            name: 'Status',
            cell: (row) =>
                <Chip label={row.status}
                    className={row.status === "Approved" ? "e-bg-green-crayola" : row.status === "Rejected" ? "e-bg-maximum-red" : "e-bg-marigold"} />,
            width: "140px"
        },
        {
            name: 'Rejection Reason',
            selector: row => row.reason,
            width: "360px"
        },
        {
            name: 'Timestamp',
            selector: row => row.time,
            width: "220px"
        },
    ];

    return (
        <div>
            <div className='padding-32px-top padding-32px-lr pb-3'>
                <h6 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                    Non Financial Changes
                </h6>
            </div>
            <div className='e-data-table-wrapper-default-updated pt-0 pb-4'>
                <CustomDataTable columns={FAMILY_TABLE_COLUMN}
                    data={TABLE_DATA}
                    pagination={true}
                    paginationPerPage={10}
                    paginationDefaultPage={currentPage}
                    paginationTotalRows={10}
                    lastPage={1}
                    onChangePage={_handlePageChange}
                />
            </div>
        </div>
    )
}

export default NonFinancialChanges;
